import type { PropsWithChildren, ReactElement } from "react";

type Props = PropsWithChildren<
	| { isHeader: true; scope: "col" | "row" }
	| {
			isHeader?: false;
	  }
>;

/**
 *
 *
 * @param props The props for the component.
 * @returns The component.
 */
export default function Cell(props: Props): ReactElement {
	const { children, isHeader, ...rest } = props;
	const CellType = isHeader ? "th" : "td";
	return (
		<CellType
			className={
				"dl:border-t dl:border-black/10! dl:text-center dl:whitespace-pre-line dl:[&_a]:text-deepocean-500"
			}
			{...rest}
		>
			{children}
		</CellType>
	);
}
